import { apiClient, apiFormData } from '@/services';

export const DealerCalculationService = {
  getCalculations() {
    return apiClient.get('/calculation');
  },
  createCalculation(params) {
    return apiClient.post('/calculation', params);
  },
  updateCalculation(id, params) {
    return apiClient.post(`/calculation/${id}/edit`, params);
  },
  deleteCalculation(id) {
    return apiClient.delete(`/calculation/${id}`);
  },
  getOfferToolSettings() {
    return apiClient.get('calculation/settings');
  },
  updateOfferToolSettings(params) {
    return apiClient.patch('calculation/settings', params);
  },
  updateSettingsLogo(params) {
    return apiFormData.post('calculation/settings_logo', params);
  },
};
